import { CurrentFlow } from 'enums/CurrentFlow';
import { useSelector } from 'react-redux';
import { getApplicationStep } from 'selectors/getApplicationStep';

const useCurrentFlow = () => {
  const { currentFlow } = useSelector(getApplicationStep);

  return {
    currentFlow,
    isCardFlow: currentFlow === CurrentFlow.Card,
    isDebtConsolidationFlow: currentFlow === CurrentFlow.DebtConsolidation,
    isFinancialCheckupFlow: currentFlow === CurrentFlow.FinancialCheckup,
    isMissedPaymentFlow: currentFlow === CurrentFlow.MissedPayment,
    isAICoachFlow: currentFlow === CurrentFlow.AICoach,
  };
};

export default useCurrentFlow;
